import React from "react";
import { Link } from "react-router-dom";
import { Footer } from "@/components/landing/Footer";
import { WaveIcon } from "@/components/landing/Decorations";

export default function CookiesPage() {
    return (
        <div className="min-h-screen bg-cream-100 text-ink">
            <header className="border-b border-cream-300 bg-white/80 backdrop-blur">
                <div className="mx-auto max-w-[1080px] px-5 sm:px-8 py-4 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2.5">
                        <WaveIcon color="#FF5B3E" className="w-6 h-4"/>
                        <span className="font-display text-[22px] font-semibold tracking-tight">Audo</span>
                    </Link>
                    <Link to="/" className="text-[13px] text-ink-muted hover:text-coral transition-colors">Back to home</Link>
                </div>
            </header>

            <main className="mx-auto max-w-[900px] px-5 sm:px-8 py-10 sm:py-14">
                <p className="text-[11px] uppercase tracking-[0.2em] font-semibold text-coral mb-2">Legal</p>
                <h1 className="font-display text-[40px] sm:text-[52px] leading-[1.05] font-semibold tracking-tight mb-4">Cookie Policy</h1>
                <p className="text-[14px] text-ink-muted mb-8">Last updated: April 27, 2026</p>

                <div className="bg-white border border-cream-300 rounded-3xl p-6 sm:p-8 space-y-6 text-[14px] leading-relaxed">
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">1. What cookies are used for</h2>
                        <p>Audo uses cookies and similar storage mechanisms to keep you signed in, remember session preferences, protect account security, and improve performance.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">2. Types we use</h2>
                        <p>Essential cookies for login/session, functional cookies for settings, and limited analytics signals for usage insights.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">3. Managing cookies</h2>
                        <p>You can control cookies through your browser settings. Blocking essential cookies may prevent login and dashboard features from working correctly.</p>
                    </section>
                    <section>
                        <h2 className="font-semibold text-[18px] mb-2">4. Contact</h2>
                        <p>Questions about cookies can be sent to <a href="mailto:contact@audo.dev" className="text-coral hover:underline">contact@audo.dev</a>.</p>
                    </section>
                </div>
            </main>

            <Footer/>
        </div>
    );
}
